module.exports = {"341825100":"旌阳镇","341825101":"蔡家桥镇","341825102":"三溪镇","341825103":"庙首镇","341825104":"白地镇","341825105":"俞村镇","341825106":"兴隆镇","341825107":"孙村镇","341825108":"版书镇","341825202":"云乐乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341825.json
// module id = 1063
// module chunks = 0